module.exports = __webpack_public_path__ + "static/media/eyob.c309421f.jpg";